import { trendingEvents } from '@/mocks/memes';

const floaters = [
  { icon: '🍉', cls: 'left-[6%] top-24 text-4xl', dur: 'animate-floaty' },
  { icon: '🔥', cls: 'left-[18%] bottom-20 text-3xl', dur: 'animate-floaty [animation-delay:1s]' },
  { icon: '😆', cls: 'right-[8%] top-28 text-5xl', dur: 'animate-floaty [animation-delay:.6s]' },
  { icon: '💬', cls: 'right-[22%] bottom-16 text-3xl', dur: 'animate-floaty [animation-delay:1.4s]' },
];

const quickTags = ['打工人', '宠物卖萌', '恋爱脑', '追剧上头', '干饭日常', '游戏翻车'];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-gradient-to-b from-background-100 via-background-50 to-background-50">
      <div className="pointer-events-none absolute inset-0 select-none" aria-hidden="true">
        {floaters.map((f, i) => (
          <span key={i} className={`absolute ${f.cls} ${f.dur} opacity-70`}>{f.icon}</span>
        ))}
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-14 pt-28 md:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:pb-20 lg:pt-32">
        <div>
          <a
            href="#trending"
            className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-700"
          >
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            今日热瓜持续更新中
          </a>

          <h1 className="mt-6 font-heading text-4xl leading-[1.15] text-foreground-950 sm:text-5xl lg:text-[3.4rem]">
            每天一点瓜，
            <br />
            <span className="text-primary-600">存图聊天两不误</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 sm:text-lg">
            每日看瓜是一处<b className="font-bold text-foreground-900">热门事件表情包仓库</b>。把新鲜梗图、够损的段子和笑到拍桌的神评论一网打尽，网友二创脑洞全收——存图发群，吃瓜氛围直接拉满。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#gallery"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              逛表情包仓库 <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="#trending"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-7 py-3.5 text-base font-bold text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              🔥 看看今日热瓜
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-2">
            {quickTags.map((t) => (
              <a
                key={t}
                href="#gallery"
                className="whitespace-nowrap rounded-full bg-background-100 px-3.5 py-1.5 text-sm text-foreground-600 ring-1 ring-background-200 transition-colors hover:bg-accent-100 hover:text-accent-900"
              >
                {t}
              </a>
            ))}
          </div>
        </div>

        {/* 右侧表情包展示角标 */}
        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative rounded-[1.6rem] border-2 border-dashed border-primary-300 bg-white p-6 sm:p-7">
            <span className="absolute -right-3 -top-3 rounded-full bg-accent-500 px-4 py-1.5 text-xs font-bold text-background-50">今日爆款</span>
            <p className="font-label text-xs tracking-wide text-foreground-500">今日表情包仓库 · TOP 热门梗</p>
            <ul className="mt-4 space-y-4">
              {trendingEvents.slice(0, 4).map((e) => (
                <li key={e.id}>
                  <a href="#trending" className="group flex items-center gap-3 rounded-2xl p-2 transition-colors hover:bg-background-100">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 text-lg text-background-50">
                      {e.tag.split(' ')[1]}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-sm font-bold text-foreground-900 group-hover:text-primary-700">{e.title}</p>
                      <p className="truncate text-xs text-foreground-500">{e.stickerText}</p>
                    </div>
                    <i className="ri-arrow-right-s-line ml-auto text-xl text-foreground-300"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <span className="absolute -bottom-4 -left-3 rounded-2xl bg-accent-500 px-4 py-2 text-sm font-bold text-background-50 shadow-sm">1286+ 表情包</span>
        </div>
      </div>

      {/* 热搜跑马灯 */}
      <div className="relative border-t border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-7xl items-center px-4 py-3 md:px-6">
          <span className="z-10 mr-4 inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-500 px-3 py-1 text-xs font-bold text-background-50">
            🔥 热搜吃瓜榜
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-drift gap-8">
              {[...trendingEvents, ...trendingEvents].map((e, i) => (
                <a key={`${e.id}-${i}`} href="#trending" className="whitespace-nowrap text-sm text-foreground-600 hover:text-primary-700">
                  <span className="mr-2 font-bold text-primary-600">{i % trendingEvents.length + 1}</span>
                  {e.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}